import React from 'react';
import { ArrowLeft } from 'lucide-react';

const SimpleContactButton = ({ className = "" }) => {
  return (
    <div className={`flex justify-center items-center mb-12 ${className}`}>
      <button
        onClick={() => {
          // אפשר להחליף ל-Link אם רוצה ניווט
          window.location.href = '/contact';
        }}
        className="
          bg-gray-800 text-white px-8 py-4 md:px-10 md:py-5 rounded-lg font-bold text-lg md:text-xl
          shadow-md hover:shadow-lg hover:bg-gray-700
          transition-all duration-300
          inline-flex items-center gap-3
          max-w-fit
        "
      >
        <span>השאירו פרטים לייעוץ ראשוני</span>
        <ArrowLeft className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SimpleContactButton;